import { render, staticRenderFns } from "./mySwiper.vue?vue&type=template&id=5bd5c19e&scoped=true&"
import script from "./mySwiper.vue?vue&type=script&lang=js&"
export * from "./mySwiper.vue?vue&type=script&lang=js&"
import style0 from "./mySwiper.vue?vue&type=style&index=0&id=5bd5c19e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd5c19e",
  null
  
)

export default component.exports